import { Box, Grid } from '@mui/material';
import { memo } from 'react';
import ProjectResultInfo from '../ProjectResultInfo';
import GridResultInfo from './GridResultInfo';

function StepperDC5(): JSX.Element {
  return (
    <Grid item xs={12}>
      <Box sx={{ px: '1.625rem' }}>
        <Grid
          container
          spacing={2}
          sx={{
            mt: '1.5rem',
            width: '100%',
            display: 'flex',
            justifyContent: { xs: 'flex-start', lg: 'center' },
          }}
        >
          <Grid item xs={12} sm={8} lg={5}>
            <ProjectResultInfo type="dcInputs" />
          </Grid>
          <Grid item xs={12} sm={8} lg={7}>
            <Box
              sx={theme => ({
                overflow: 'auto',
                borderRadius: '7px',
                border: `1px solid ${theme.palette.divider}`,
                p: 1,
              })}
            >
              <GridResultInfo />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}

export default memo(StepperDC5);
